import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { ListaFormaDefault, SeriePredeterminada } from '@app/shared';
import { QRCategorias, QRTypes, SubSeriePredeterminada, TypePreviewSticker } from '../../../../shared/models/documento.model';

@Injectable()
export class ManageFormDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  getForms(): Observable<ListaFormaDefault[]> {
    return new Observable(obs => {
      this.http.get<ListaFormaDefault[]>(this.api.get('dynamicFormVersion')).subscribe(
        forms => {
          forms.forEach(form => {
            if (form.forma_especifica) {
              form.nombre_alternativo = form.descripcion;
            } else {
              form.nombre_alternativo = form.nombre.charAt(0).toUpperCase() +
                                        form.nombre.replace('_', ' ').slice(1);
            }
          });

          obs.next(forms);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


/**
 * Consultar todas las series
 *
 * @returns {Observable<SeriePredeterminada[]>}
 * @memberof ManageFormDataService
 */
  getSeries(): Observable<SeriePredeterminada[]> {
    return new Observable(obs => {
      this.http.get<SeriePredeterminada[]>(this.api.get('adminSerie')).subscribe(
        series => {
        obs.next(series);
      },
      err => {
        obs.error(err);
      });
    });
  }

/**
 * Consultar todas las subseries
 *
 * @returns {Observable<SubSeriePredeterminada[]>}
 * @memberof ManageFormDataService
 */
   getSubSeries(serie: any): Observable<any[]> {
    return new Observable(obs => {
      this.http.get<SubSeriePredeterminada[]>(this.api.get('adminSubSerie')).subscribe(
        subSeries => {
          const rtn: any [] = [];
          if (subSeries && subSeries.length && serie) {
            subSeries.forEach(e => {
              if (e.serie.id === serie.id ) {
              delete e.serie;
              rtn.push(e);
              }
            });
          } else if (serie) {
            rtn.push(subSeries);
          } else {
            return [];
        }
        obs.next(rtn);
      },
      err => {
        obs.error(err);
      });
    });
  }

/**
 * Consultar todas las series
 *
 * @returns {Observable<any[]>}
 * @memberof ManageFormDataService
 */
 getTypeFormParameters(): Observable<any[]> {
  return new Observable(obs => {
    this.http.get<any[]>(this.api.get('documentExpInventorySearch')).subscribe(
      series => {
      obs.next(series);
    },
    err => {
      obs.error(err);
    });
  });
}

/**
 * Consultar todos los tipos de qr disponibles
 *
 * @returns {Observable<QRTypes[]>}
 * @memberof ManageFormDataService
 */
 getQRTypes(): Observable<QRTypes[]> {
  return new Observable(obs => {
    this.http.get<QRTypes[]>(this.api.get('qrTypes')).subscribe(
      qrT => {
      obs.next(qrT);
    },
    err => {
      obs.error(err);
    });
  });
}

/**
 * Consultar todos los tipos de qr disponibles
 *
 * @returns {Observable<QRCategorias[]>}
 * @memberof ManageFormDataService
 */
 getQRCategory(): Observable<QRCategorias[]> {
  return new Observable(obs => {
    this.http.get<QRCategorias[]>(this.api.get('qrCategory')).subscribe(
      qr => {
      obs.next(qr);
    },
    err => {
      obs.error(err);
    });
  });
}

/**
 * Consultar todos los tipos de qr disponibles
 *
 * @returns {Observable<TypePreviewSticker[]>}
 * @memberof ManageFormDataService
 */
 getTypesPreview(): Observable<TypePreviewSticker[]> {
  return new Observable(obs => {
    this.http.get<TypePreviewSticker[]>(this.api.get('previewStickerDocument')).subscribe(
      type => {
      obs.next(type);
    },
    err => {
      obs.error(err);
    });
  });
}

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-form/shared/manage-form.data.service.ts